import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IVideoMetaDataKeywords, defaultValue } from 'app/shared/model/video-meta-data-keywords.model';

export const ACTION_TYPES = {
  FETCH_VIDEOMETADATAKEYWORDS_LIST: 'videoMetaDataKeywords/FETCH_VIDEOMETADATAKEYWORDS_LIST',
  FETCH_VIDEOMETADATAKEYWORDS: 'videoMetaDataKeywords/FETCH_VIDEOMETADATAKEYWORDS',
  CREATE_VIDEOMETADATAKEYWORDS: 'videoMetaDataKeywords/CREATE_VIDEOMETADATAKEYWORDS',
  UPDATE_VIDEOMETADATAKEYWORDS: 'videoMetaDataKeywords/UPDATE_VIDEOMETADATAKEYWORDS',
  DELETE_VIDEOMETADATAKEYWORDS: 'videoMetaDataKeywords/DELETE_VIDEOMETADATAKEYWORDS',
  RESET: 'videoMetaDataKeywords/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IVideoMetaDataKeywords>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type VideoMetaDataKeywordsState = Readonly<typeof initialState>;

// Reducer

export default (state: VideoMetaDataKeywordsState = initialState, action): VideoMetaDataKeywordsState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_VIDEOMETADATAKEYWORDS_LIST):
    case REQUEST(ACTION_TYPES.FETCH_VIDEOMETADATAKEYWORDS):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_VIDEOMETADATAKEYWORDS):
    case REQUEST(ACTION_TYPES.UPDATE_VIDEOMETADATAKEYWORDS):
    case REQUEST(ACTION_TYPES.DELETE_VIDEOMETADATAKEYWORDS):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_VIDEOMETADATAKEYWORDS_LIST):
    case FAILURE(ACTION_TYPES.FETCH_VIDEOMETADATAKEYWORDS):
    case FAILURE(ACTION_TYPES.CREATE_VIDEOMETADATAKEYWORDS):
    case FAILURE(ACTION_TYPES.UPDATE_VIDEOMETADATAKEYWORDS):
    case FAILURE(ACTION_TYPES.DELETE_VIDEOMETADATAKEYWORDS):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_VIDEOMETADATAKEYWORDS_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_VIDEOMETADATAKEYWORDS):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_VIDEOMETADATAKEYWORDS):
    case SUCCESS(ACTION_TYPES.UPDATE_VIDEOMETADATAKEYWORDS):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_VIDEOMETADATAKEYWORDS):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/video-meta-data-keywords';

// Actions

export const getEntities: ICrudGetAllAction<IVideoMetaDataKeywords> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_VIDEOMETADATAKEYWORDS_LIST,
  payload: axios.get<IVideoMetaDataKeywords>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<IVideoMetaDataKeywords> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_VIDEOMETADATAKEYWORDS,
    payload: axios.get<IVideoMetaDataKeywords>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IVideoMetaDataKeywords> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_VIDEOMETADATAKEYWORDS,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IVideoMetaDataKeywords> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_VIDEOMETADATAKEYWORDS,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IVideoMetaDataKeywords> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_VIDEOMETADATAKEYWORDS,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
